import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Permissoes from '../permissoes';

const GRUPOS_POR_PERMISSAO = {
  [Permissoes.FUNCIONARIO]: 'Funcionários',
  [Permissoes.FUNCIONARIO_CADASTRO]: 'Funcionários',
  [Permissoes.VEICULO]: 'Veículos',
  [Permissoes.VEICULO_CADASTRO]: 'Veículos',
  [Permissoes.RELATORIO]: 'Relatórios',
  [Permissoes.RELATORIO_VEICULO]: 'Relatórios',
  [Permissoes.MERCADORIA]: 'Mercadorias',
  [Permissoes.MERCADORIA_CADASTRO]: 'Mercadorias',
  [Permissoes.ALMOXARIFADO]: 'Almoxarifado',
  [Permissoes.ALMOXARIFADO_CADASTRO]: 'Almoxarifado',
  [Permissoes.EPI]: 'EPI',
  [Permissoes.EPI_CADASTRO]: 'EPI',
  [Permissoes.ROMANEIO]: 'Romaneio',
  [Permissoes.FLUXO_CAIXA]: 'Fluxo de Caixa',
  [Permissoes.SETOR]: 'Setor',
  [Permissoes.SC]: 'Solicitação de Compra',
  [Permissoes.APROVA_SC]: 'Solicitação de Compra',
  [Permissoes.PROPOSTA_COMERCIAL]: 'Proposta Comercial',
  [Permissoes.MEDICAO]: 'Medição',
  [Permissoes.ORDEM_SERVICO]: 'Ordem de Serviço',
  [Permissoes.DOCUMENTO_CADASTRO]: 'Documentos',
  [Permissoes.TI]: 'Administração',
};

const ORDEM_GRUPOS = [
  'Funcionários', 'Veículos', 'Relatórios', 'Mercadorias', 'Almoxarifado', 'EPI',
  'Romaneio', 'Fluxo de Caixa', 'Setor', 'Solicitação de Compra', 'Proposta Comercial',
  'Medição', 'Ordem de Serviço', 'Documentos', 'Administração', 'Outras permissões',
];

function PermissoesPicker({ permissoesDisponiveis, selecionadas, onToggle, onToggleGrupo }) {
  const grupos = {};
  permissoesDisponiveis.forEach((permissao) => {
    const grupo = GRUPOS_POR_PERMISSAO[permissao.nome] || 'Outras permissões';
    if (!grupos[grupo]) grupos[grupo] = [];
    grupos[grupo].push(permissao);
  });

  const gruposOrdenados = Object.keys(grupos).sort(
    (a, b) => ORDEM_GRUPOS.indexOf(a) - ORDEM_GRUPOS.indexOf(b)
  );

  return (
    <Box>
      {gruposOrdenados.map((grupo) => {
        const permissoesDoGrupo = grupos[grupo];
        const idsGrupo = permissoesDoGrupo.map((p) => p.nome);
        const selecionadasNoGrupo = idsGrupo.filter((id) => selecionadas.includes(id)).length;
        const todasSelecionadas = selecionadasNoGrupo === idsGrupo.length;

        return (
          <Accordion key={grupo} defaultExpanded={selecionadasNoGrupo > 0} disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                <Typography sx={{ fontWeight: 600, flexGrow: 1 }}>{grupo}</Typography>
                <Chip
                  size="small"
                  label={`${selecionadasNoGrupo}/${idsGrupo.length}`}
                  color={selecionadasNoGrupo > 0 ? 'secondary' : 'default'}
                  variant={selecionadasNoGrupo > 0 ? 'filled' : 'outlined'}
                />
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {onToggleGrupo && idsGrupo.length > 1 && (
                <FormControlLabel
                  sx={{ mb: 0.5 }}
                  control={
                    <Checkbox
                      size="small"
                      checked={todasSelecionadas}
                      indeterminate={selecionadasNoGrupo > 0 && !todasSelecionadas}
                      onChange={() => onToggleGrupo(idsGrupo, !todasSelecionadas)}
                    />
                  }
                  label={<Typography variant="body2" sx={{ fontStyle: 'italic' }}>Marcar todas</Typography>}
                />
              )}
              <FormGroup>
                {permissoesDoGrupo.map((permissao) => (
                  <FormControlLabel
                    key={permissao.nome}
                    control={
                      <Checkbox
                        size="small"
                        checked={selecionadas.includes(permissao.nome)}
                        onChange={() => onToggle(permissao.nome)}
                        color="secondary"
                      />
                    }
                    label={permissao.label || permissao.nome}
                  />
                ))}
              </FormGroup>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}

export default PermissoesPicker;
